
<article class="pickup-ad-link-item-wrapper" @click="handleClick">
  <div class="image">
    <img :src="imageUrl" alt="ピックアップ広告画像" />
  </div>
  <div class="description">
    <p class="title-wrap">
      <ArticleTag v-if="tag && tagColor" :tag-color="tagColor" class="tag">{{ tag }}</ArticleTag
      ><span class="title">{{ title }}</span>
    </p>
    <p class="sponsor">{{ sponsorName }}</p>
  </div>
</article>
